import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import setStartDate from '../actions/setStartDate';
import { orchestrator } from 'satcheljs';
export default orchestrator(setStartDate, function (actionMessage) {
    var date = actionMessage.date;
    if (date) {
        updateCalendarEventsToDecline();
    }
});
//# sourceMappingURL=onSetStartDateOrchestrator.js.map